import { Component } from "@angular/core";
import { ContactFormComponent } from "../../../shared/contact-form/contact-form.component";
import { HeroComponent } from "../../../shared/hero/hero.component";
import { PerksAndBenefitsComponent } from "../../../shared/perks-and-benefits/perks-and-benefits.component";
import { HR_CONFIG } from "../../../shared/contact-form/contact-config";
import { JobOffersComponent } from "../../components/job-offers/job-offers.component";
import { NavbarComponent } from "../../components/navbar/navbar.component";
import { RecruitmentComponent } from "../../components/recruitment/recruitment.component";
import { WhyComponent } from "../../components/why/why.component";

@Component({
  selector: "app-careers",
  templateUrl: "./careers.component.html",
  styleUrls: ["./careers.component.scss"],
  imports: [
    HeroComponent,
    ContactFormComponent,
    NavbarComponent,
    WhyComponent,
    PerksAndBenefitsComponent,
    RecruitmentComponent,
    JobOffersComponent,
  ],
})
export class CareersComponent {
  protected readonly HR_CONFIG = HR_CONFIG;
  public heroConfig = {
    slogan: "Join our team and unleash your potential",
    subpageTitle: "careers",
    subSlogan: "Why NiceProject?",
    buttonText: "Join our NiceTeam",
    buttonLink: "",
    background: "career-bg",
  };
}
